import { computed, defineComponent, watch } from "@vue/composition-api";
import useUserPublicData from "@/hooks/useUserPublicData";
import { userPublicDataFieldsWithStoryInfo } from "@/lib/fieldsHelper";
import { ROLES } from "@/const";

export default defineComponent({
  name: "usersLiveController",
  props: {
    role: { type: String as () => ROLES, required: true },
  },
  setup(props, { root, emit }) {
    const { data, render, getFirstPage } = useUserPublicData(
      computed(() => ({ role: "creator", isLive: true, discoveryOnly: true })),
      undefined,
      userPublicDataFieldsWithStoryInfo()
    );
    getFirstPage().then(() => emit("load", data.value?.totalRecords));

    watch(
      () => props.role,
      () => {
        if (props.role !== ROLES.CREATOR) {
          root.$router.replace({ name: "usersAll" });
        }
      }
    );
    return render;
  },
});
